// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"aeeb9cc4","173":"097df969","196":"3c817764","287":"f56115e7","322":"1974f9fe","474":"01f8ddac","504":"69ec510e","715":"407088a8","777":"32cd7305","819":"ae0e5458","953":"5339a60e"}[chunkId] + ".chunk.js";
};